import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import Index from './views/Index'
import temp1 from './views/temp/temp1'
import temp2 from './views/temp/temp2'
import temp3 from './views/temp/temp3'
//
import warp from './components/warp'
import grid from './views/grid'
import forms from './views/forms'
import swiper from './views/swiper'

//
import Comp from './views/Comp'
import thumbnail from './views/comp/thumbnail'
//
import chart from './views/chart'

//

//
Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'home',
		component: temp1,
		meta: {
			keepAlive: true
		}
	}, {
		path: '/index',
		component: Index,
		meta: {
			keepAlive: true
		},
		children: [{
			path: '',
			name: "index",
			component: warp,
			meta: {
				keepAlive: true
			}
		}, {
			path: 'temp1',
			component: temp1,
			meta: {
				keepAlive: true
			}
		}, {
			path: 'temp2',
			component: temp2,
			meta: {
				keepAlive: true
			}
		}, {
			path: 'temp3',
			component: temp3,
			meta: {
				keepAlive: true
			}
		}]
	}, {
		path: '/grid',
		component: grid,
		name: 'gride',
		meta: {
			keepAlive: true
		}
	}, {
		path: '/forms',
		component: forms,
		name: 'forms',
		meta: {
			keepAlive: false
		}
	}, {
		path: '/chart',
		component: chart,
		name: 'chart',
		meta: {
			keepAlive: false
		}
	}, {
		path: '/swiper',
		component: swiper,
		name: 'swiper',
		meta: {
			keepAlive: true
		}
	}, {
		path: '/comps',
		component: Comp,
		name: 'comps',
		meta: {
			keepAlive: true
		},
		children: [{
			path: 'thumbnail',
			component: thumbnail,
			name:"thumbnail",
			meta: {
				keepAlive: true
			}
		}]
	}]
})

export default router


// WEBPACK FOOTER //
// ./src/routes.js